import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from "apollo-link-context";
import VueApollo from 'vue-apollo'
import { store, mutations } from "../utils/store";

const options = {
  uri: process.env.VUE_APP_API_URL + "/graphql",
  credentials: 'same-origin',
}

// HTTP connexion to the API
const httpLink = new HttpLink(options)

// Authorization Headers
const authLink = setContext((_, { headers }) => {
  const token = store.token || store.queryToken;

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ""
    }
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (networkError) {
    if (networkError.statusCode == 401) {
      mutations.logout();
      window.location = `/login?return=${encodeURI(window.location)}`;
    } else {
      alert(`Network Error: ${networkError}`)
    }
  } else if (graphQLErrors) {
    alert(`GraphQL Error :\n${graphQLErrors.map(e => e.message).join('\n')}`)
  }
});

// Cache
const cache = new InMemoryCache()

// Create the apollo client
const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    errorLink,
    authLink,
    httpLink,
  ]),
  cache,
})

export const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})